"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ssr_storage_1 = require("./ssr-storage");
class StorageAdapter {
    constructor(storageKey, storeType = StorageAdapter.types.LOCAL_STORAGE) {
        if (!storageKey) {
            throw new Error('Storage needs a storageKey');
        }
        this.storageKey = storageKey;
        this.store = null;
        this.storage = storeType;
    }
    get type() {
        return this.$type || 'invalid';
    }
    static get types() {
        return {
            SESSION_STORAGE: 'sessionStorage',
            LOCAL_STORAGE: 'localStorage',
        };
    }
    get storage() {
        return this.store;
    }
    isAvailable() {
        return !!this.store;
    }
    set storage(storageType_) {
        let storageToUse;
        if (typeof window !== 'undefined') {
            switch (storageType_) {
                case StorageAdapter.types.SESSION_STORAGE:
                    storageToUse = window.sessionStorage;
                    break;
                case StorageAdapter.types.LOCAL_STORAGE:
                    storageToUse = window.localStorage;
                    break;
                default:
                    storageToUse = null;
            }
        }
        else {
            storageToUse = new ssr_storage_1.SsrStorage();
        }
        const errorObj = StorageAdapter.testStoreAvailability(storageToUse);
        if (!errorObj.error) {
            this.store = storageToUse;
            this.$type = storageType_;
        }
        else {
            this.store = null;
            console.warn(`${storageType_}|${storageToUse}  is not available`, errorObj.error);
        }
    }
    static testStoreAvailability(storeToUse_) {
        const mod = 'storagetest';
        try {
            storeToUse_.setItem(mod, mod);
            storeToUse_.removeItem(mod);
            return {};
        }
        catch (err) {
            return { error: err };
        }
    }
    writeEntry(item_ = {}) {
        let success = false;
        if (this.isAvailable()) {
            try {
                this.storage.setItem(this.storageKey, JSON.stringify(item_));
                success = true;
            }
            catch (err) {
                console.warn(`could not write entry to storage '${this.storageKey}'`, err);
                success = false;
            }
        }
        return success;
    }
    clearStorage() {
        if (this.storage) {
            this.storage.removeItem(this.storageKey);
            this.store = null;
        }
    }
    readEntry() {
        let entry = null;
        if (this.isAvailable()) {
            const item = this.storage.getItem(this.storageKey);
            try {
                if (item === undefined) {
                    return null;
                }
                entry = JSON.parse(item);
            }
            catch (err) {
                console.warn(`could not parse entry from storage '${this.storageKey}'`, err);
                entry = null;
            }
        }
        return entry || null;
    }
}
exports.default = StorageAdapter;
//# sourceMappingURL=storage-adapter.js.map